import React from "react";
import { UserIcon } from "components/Icons";
import { gotoUrl } from "utils/helpers";
import { paths } from "utils/constants";
import { get } from "lodash";
import { Box, Flex, Text } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import { COLORS } from "ui-components/theme";

const ProfileIcon = ({
  profileImageUrl,
  visibility = false,
  data = {},
  defaultRedirectUrl,
  themeColors,
  isLoggedIn
}) => {
  const { avatarStyles = {}, defaultProfileImageUrl } = data;

  const redirectUrl = get(data, "defaultRedirectUrl") || defaultRedirectUrl;

  const onClickEvent = () => {
    if (!visibility) {
      gotoUrl(redirectUrl);
    } else {
      gotoUrl(paths.PROFILE);
    }
  };

  return (
    <>
      {!isLoggedIn && (
        <Box id="action-link">
          <>
            <Box mt="20px" data-testid="login" onClick={() => onClickEvent()}>
              <Text
                style={{
                  color: COLORS.purple[7],
                  fontSize: "16px",
                  fontWeight: "700",
                  cursor: "pointer",
                  textAlign: "center",
                  paddingRight: "10px",
                  paddingBottom: "12px"
                }}
              >
                <FormattedMessage html id={"login_signup_path"} />
              </Text>
            </Box>
          </>
        </Box>
      )}
      <Flex
        onClick={() => onClickEvent()}
        gtmdata={{
          containerName: "profile-image",
          altContainerName: null
        }}
      >
        <UserIcon
          color={themeColors?.primary}
          src={profileImageUrl || defaultProfileImageUrl}
          data-testid="profile-image"
          style={avatarStyles}
          size="32px"
          gtmdata={{
            containerName: "profile-image",
            altContainerName: null
          }}
        />
      </Flex>
    </>
  );
};

ProfileIcon.defaultProps = {
  defaultRedirectUrl: "/web/signup"
};

export default ProfileIcon;
